import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import ScrollButton from '../components/scroll_button';
import InfoSection from '../components/info_section';
import Layout from '../components/layout';
import Image from 'next/image';
import styles from '../styles/billing.module.scss';
import BillingService from '../public/billing.svg';
import Modal from '../components/contactUsModal';
import RelatedServices from '../components/relatedServices';
import LocationAdmin from '../svgs/relatedServices/locationAdmin.svg'
import AccountSettings from '../svgs/relatedServices/accountSettings.svg'

const relatedServices = [
  {
    title: 'Location Admin',
    img: LocationAdmin,
    link: '/location-admin'
  },
  {
    title: 'Account Settings',
    img: AccountSettings,
    link: '/account-settings'
  }
];

export default function Billing() {
  const router = useRouter();
  const { t } = useTranslation('billing');

  return (
    <Layout title={t('metaTitle')} lang={router.locale} route={router.route} isHeader isFooter>
      <ScrollButton scrollStepInPx='50' delayInMs='16.66' />
      <InfoSection
        title='Billing'
        description='billingDescription'
        documentationLink='https://help.icdc.io/billing/'
        lang={router.locale}
      />

      <div className={styles.service} >
        <section className={styles.whatIsIt}>
          <div className={styles.serviceImg}>
            <Image src={BillingService} alt={t("billingServiceAlt")} />
          </div>
          <h2>{t('whatIsService.title')}</h2>
          <p dangerouslySetInnerHTML={{ __html: t('whatIsService.description', { interpolation: { escapeValue: false } }) }} />
        </section>

        <section className={'flex col ' + styles.key_features}>
          <h2>{t('features.title')}</h2>
          <div className={styles.container}>
            {new Array(3).fill('').map((_, key) => (
              <div className={styles.item} key={key}>
                <img src={`/icons/billing/key_feature${key + 1}.svg`} alt={t("keyFeatureAlt")} />
                <h3>{t(`features.title${key + 1}`)}</h3>
                <p>{t(`features.description${key + 1}`)}</p>
              </div>
            ))}
          </div>
        </section>

        <section className={styles.benefits}>
          <div className={styles.benefitsWrapper}>
            <h2>{t('cases.title')}</h2>
            {new Array(3).fill('').map((_, key) => (
              <div className={styles.item} key={key}>
                <img src={`/icons/billing/key_solution${key + 1}.svg`} alt={t("keySolutionAlt")} />
                <h3>{t(`cases.title${key + 1}`)}</h3>
                <p>{t(`cases.description${key + 1}`)}</p>
              </div>
            ))}
            <a href={t('cases.docUrl')} target="_blank">
              <button className={'btn white'}>{t('cases.doc')}</button>
            </a>
          </div>
        </section>

        <section className={styles.questions}>
          <h3>{t('contact.title')}</h3>
          <p>{t('contact.desc')}</p>
          <Modal lang={router.locale} blue />
        </section>

        <section>
          <RelatedServices services={relatedServices} />
        </section>
      </div>
    </Layout>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...await serverSideTranslations(locale, ['billing', 'common']),
  },
});
